let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("i3jpZ")).then(() => parcelRequire('9VamR'));